<template>
  <div class="couponList">
    <button type="button"
      :class="{item: true, addItem: true}"
      @click="setNewItem"
      :disabled="couponLimit">
      +
    </button>
    <CouponItem v-for="item in list" :key="item.cid"
      :locale="locale"
      :item="item"
      @getItem="setItem" />
  </div>
</template>

<script>
import CouponItem from '@/components/Coupon/Item.vue'
export default {
  name: 'CouponList',
  props: [
    'locale',
    'isActive',
    'list',
    'couponLimit'
  ],
  components: {
    CouponItem
  },
  watch: {
    isActive (isActive) {
      if (!isActive) {
        this.active = false
      }
    }
  },
  data () {
    return {
      active: false
    }
  },
  methods: {
    setNewItem () {
      this.active = true
      this.$store.commit('coupon/initSetInfo')
      this.$emit('setDetail', true)
    },
    setItem () {
      this.active = false
      this.$emit('setDetail', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.addItem {
  font-size: 4em;
  color: $color-grey;
  &.active {
    color: $color-primary;
  }
  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>
